import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {ContentStyled} from '../../styles/components/content.style';
import {H2} from '../../styles/components/typography.style';
import {Button2a} from '../../styles/components/button.style';

export const ContentWrapper = ContentStyled.extend`
  background: ${p => p.theme.tableBookingPage.backgroundColor};
  width: ${p => p.theme.tableBookingPage.width};
  text-align: left;
  margin-top: ${p => p.theme.tableBookingPage.offsetTop};
  ${media.small`
    width: 100%;
    margin: 0;
  `};
`;

export const Title = H2.extend`
  margin-top: ${p => p.theme.margin};
  text-align: left;
`;

export const Subtitle = styled.span`
  font-size: ${p => p.theme.tableBookingPage.fontSize};
`;

export const Block = styled.div`
  padding: ${p => p.theme.feedbackPage.padding.question};
`;

export const SubBlock = styled.div`
  margin-bottom: ${p => p.theme.margin};
`;

export const LoadingWrapper = styled.div`
  padding: ${p => p.theme.feedbackPage.padding.loading};
`;

export const Form = styled.div`
  background-color: ${p => p.theme.feedbackPage.colors.background};
  margin-top: ${p => p.theme.margin};
`;

export const ContentTitle = styled.span`
  display: block;
  text-transform: uppercase;
  text-align: center;
  color: ${p => p.theme.tertiaryColor};
  font-size: ${p => p.theme.feedbackPage.fontSizes.title};
  padding-top: ${p => p.theme.padding};
  padding-bottom: ${p => p.theme.padding};
  margin-bottom: ${p => p.theme.margin};
`;

export const MealBlock = styled.div`
  color: ${p => p.theme.quaternaryColor};
  font-size: ${p => p.theme.fontSize};
  margin-top: ${p => p.theme.margin};
`;

export const Question = styled.span`
  display: block;
  width: 100%;
  color: ${p => p.theme.feedbackPage.colors.text};
  padding-bottom: ${p => p.theme.padding};
  font-size: ${p => p.theme.feedbackPage.fontSizes.text};
  border-bottom: ${p => `solid 0.1rem ${p.theme.borderColor}`};
`;

export const SmallText = styled.span`
  font-size: ${p => p.theme.fontSize};
  padding-left: ${p => p.theme.padding};
`;

export const RatingWrapper = styled.div`
  width: 100%;
`;

export const Answer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: ${p => p.theme.feedbackPage.padding.content};
`;

export const AnswerText = styled.span`
  margin-top: ${p => p.theme.margin};
`;

export const CommentsWrapper = Answer.extend`
  padding: ${p => p.theme.feedbackPage.padding.comment};
`;

export const Comments = styled.textarea`
  outline: none;
  width: 100%;
  height: 9rem;
  padding: ${p => p.theme.padding};
  border: none;
`;

export const Yes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  color: ${p => p.selected ? p.theme.feedbackPage.colors.yes : p.theme.feedbackPage.colors.text};
  font-size: ${p => p.theme.feedbackPage.fontSizes.text};
  flex-basis: ${p => p.isThree ? '33%' : '50% '};
`;

export const No = Yes.extend`
  color: ${p => p.selected ? p.theme.feedbackPage.colors.no : p.theme.feedbackPage.colors.text};
`;

export const Maybe = Yes.extend`
  color: ${p => p.selected ? p.theme.feedbackPage.colors.maybe : p.theme.feedbackPage.colors.text};
`;

export const QualityGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: ${p => p.theme.feedbackPage.padding.qualityGroup};
`;

export const Quality = styled.div`
  display: flex;
  align-items: center;
  padding: ${p => p.theme.padding};
  flex-basis: 100%;
`;

export const QualityText = styled.div`
  padding-left: ${p => p.theme.padding};
  color: ${p => p.theme.feedbackPage.colors.text};
  font-size: ${p => p.theme.feedbackPage.fontSizes.text};
`;

export const GreenDot = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${p => `inset 0 0 0 0.3rem ${p.theme.feedbackPage.colors.yes}`};
  background-color: ${p => p.selected ? p.theme.feedbackPage.colors.yes : 'transparent'};
`;

export const GreenDotWithTick = GreenDot.extend`
  &:before {
    color: ${p => p.theme.feedbackPage.colors.background};
    font-size: 2.4rem;
    content: '+';
    font-weight: bold;
    transform: rotate(45deg);
    padding-left: 0.1rem;
  }
`;

export const RedWithTick = GreenDot.extend`
  box-shadow: ${p => p.selected
    ? `inset 0 0 0 0.3rem ${p.theme.feedbackPage.colors.no}`
    : `inset 0 0 0 0.3rem ${p.theme.feedbackPage.colors.unselectedNo}`
  };
  background-color: ${p => p.selected ? p.theme.feedbackPage.colors.no : 'transparent'};
  &:before {
    font-size: 2.4rem;
    content: '+';
    font-weight: bold;
    transform: rotate(45deg);
    padding-left: 0.1rem;
    color: ${p => p.theme.feedbackPage.colors.background};
  }
`;

export const RedDot = GreenDot.extend`
  box-shadow: ${p => p.selected
    ? `inset 0 0 0 0.3rem ${p.theme.feedbackPage.colors.no}`
    : `inset 0 0 0 0.3rem ${p.theme.feedbackPage.colors.unselectedNo}`
  };
  background-color: ${p => p.selected ? p.theme.feedbackPage.colors.no : 'transparent'};
`;

export const OrangeDot = GreenDot.extend`
  box-shadow: ${p => `inset 0 0 0 0.3rem ${p.theme.feedbackPage.colors.maybe}`};
  background-color: ${p => p.selected ? p.theme.feedbackPage.colors.maybe : 'transparent'};
`;

export const MealName = styled.div`
  text-transform: uppercase;
  padding: ${p => p.theme.feedbackPage.padding.mealName};
  background-color: ${p => p.theme.primaryBackground};
  font-size: ${p => p.theme.feedbackPage.fontSizes.text};
`;

export const Submit = Button2a.extend`
  margin-top: ${p => p.theme.feedbackPage.margin.submit};
  width: 100%;
  background-color: ${props => props.greyed ? props.theme.disabledButtonBackground : props.theme.secondaryColor};
  border-bottom: ${props => props.greyed ? props.theme.button.secondary.borderBottom : props.theme.button.primary.borderBottom};
`;



// WEBPACK FOOTER //
// ./containers/FeedbackPage/Feedback.style.js